// @flow
import React from 'react';

import type { CMSProps } from 'Client/cms/toolkit/tripadvisor-testimony/tripadvisorTestimony.descriptor';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { TripadvisorTestimony } from 'Components/widgets/tripadvisor-testimony/TripadvisorTestimony.jsx';

export type LineProps = CMSProps;

export const TripadvisorTestimonyLine = ({
  author,
  date,
  fullCommentLink,
  id,
  link,
  onBy,
  stars,
  text,
}: LineProps) => (
  <SiteContainer id={id} className="Line" dataTestId="Line-TripadvisorTestimony">
    <TripadvisorTestimony
      text={text}
      stars={stars}
      onBy={onBy}
      author={author}
      date={date}
      fullCommentLink={fullCommentLink}
      link={link}
    />
  </SiteContainer>
);
